import React, { useEffect, useState } from 'react';
import Banner from '../../components/Banner';
import { getActiveCommitments } from '../../api/commitments';
import { getActiveMainImages } from '../../api/commitmentMainImages';
import styles from '../../css/ourCommitment.module.css';
import section2OurCompany from '../../assets/images/our-commitment.png';
import ourCommitment from '../../assets/images/our-commiment-banner.png';




const OurCommitment = () => {
    const [articles, setArticles] = useState([]);
    const [mainImages, setMainImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    // Fetch data when component mounts
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                
                // Fetch both commitments and main images
                const [commitmentsData, mainImagesData] = await Promise.all([
                    getActiveCommitments(),
                    getActiveMainImages()
                ]);
                
                setArticles(commitmentsData);
                setMainImages(mainImagesData);
                setError('');
            } catch (err) {
                console.error('Failed to fetch data:', err);
                setError('Failed to load content. Please try again later.');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    // Create excerpt from full text
    const createExcerpt = (text, maxLength = 150) => {
        if (text.length <= maxLength) return text;
        return text.substring(0, maxLength).trim() + '...';
    };
  return (
    <div className="main-container">
      <Banner
        image={ourCommitment}
        altText="Newsroom"
        className="our-commitment-banner"
      >
      </Banner>
  
        <section className={styles.section1}>
          <div className="container">
           <p className="comp-desc">HiveRooms is more than just a hospitality technology solution; it’s now a travel marketplace
              where you can book your accommodations, travel experiences, and events in one platform.</p>
          </div>
        </section>

        <section className={styles.section2}>
            <div className="comp-categories">
                <p className={styles.desc}>Together, we grow with the community.</p>
            </div>
            <div className="container">
                {!loading && mainImages.length > 0 && (
                    <div className="banner">
                        {mainImages.map((image, index) => (
                            <img 
                                key={image._id} 
                                src={image.imageUrl} 
                                alt={`Main commitment image ${index + 1}`}
                                onError={(e) => {
                                    e.target.style.display = 'none';
                                }}
                            />
                        ))}
                    </div>
                )}
                {!loading && mainImages.length === 0 && (
                    <div className="banner">
                        <img src={section2OurCompany} alt="Default commitment image" />
                    </div>
                )}
          </div>
        </section>

        <section className={styles.section3}>
            <div className="container">
                {loading && (
                    <div className={styles.loading}>
                        <p>Loading our commitment stories...</p>
                    </div>
                )}
                
                {error && (
                    <div className={styles.error}>
                        <p>{error}</p>
                    </div>
                )}

                {!loading && !error && articles.length === 0 && (
                    <div className={styles.noArticles}>
                        <p>No commitment stories available at the moment.</p>
                    </div>
                )}

                {!loading && !error && articles.length > 0 && (
                    <div className={styles.cardsWrapper}>
                        {articles.map((article) => (
                            <div className={styles.card} key={article._id}>
                                <div className={styles.imageWrapper}>
                                    <img 
                                        src={article.imageUrl} 
                                        alt={article.title}
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                        }}
                                    />
                                </div>
                                <div className={styles.txtCont}>
                                    <h3>{article.title}</h3>
                                    <p>{createExcerpt(article.text)}</p>
                                    <a
                                        href={article.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={styles.readMore}
                                    >
                                        Read more →
                                    </a>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

        </section>  
    </div>
  );
};

export default OurCommitment;